import React from 'react';
import { FaServer, FaCalendarAlt, FaLeaf } from 'react-icons/fa';
import './HowItWorks.css';

const HowItWorks = () => {
  return (
    <div className="how-it-works-container">
      <div className="MainHome-services-container-subcontainer1-title" style={{ color: '#384D64', fontWeight: '600', marginBottom: '10px' }}>WORKING PROCESS</div>
      <h3 className="how-it-works-title">How It Works</h3>
      <p className="description">
        Our simple process makes it easy for you. Select your desired service, choose a convenient time, and our expert cleaners will handle the rest, ensuring your space is spotless.
      </p>

      <div className="steps-container">

        <div className="step">
          <div className="step-outer-circle">
            <div className="step-icon">
              <FaServer size={35} style={{ color: '#2A4765' }} />
            </div>
            <div className="no-circle">
              <div className="inner-no-circle">01</div>
            </div>
          </div>
          <div className="step-content">
            <h4 className="step-title">Select Service</h4>
            <p className="step-description">Choose the cleaning service you need from our available options.</p>
          </div>
        </div>

        <div className="step">
          <div className="step-outer-circle">
            <div className="step-icon">
              <FaCalendarAlt size={35} style={{ color: '#2A4765' }} />
            </div>
            <div className="no-circle">
              <div className="inner-no-circle">02</div>
            </div>
          </div>
          <div className="step-content">
            <h4 className="step-title">Set Schedule</h4>
            <p className="step-description"> Select a convenient time that fits perfectly into your schedule.</p>
          </div>
        </div>

        <div className="step">
          <div className="step-outer-circle">
            <div className="step-icon">
              <FaLeaf size={35} style={{ color: '#2A4765' }} />
            </div>
            <div className="no-circle">
              <div className="inner-no-circle">03</div>
            </div>
          </div>
          <div className="step-content">
            <h4 className="step-title">Cleaning Done</h4>
            <p className="step-description">Our experts will clean thoroughly, leaving your space fresh and spotless.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HowItWorks;
